import TextWidget from '../TextWidget/TextWidget';
import RadioWidget from '../RadioWidget/RadioWidget';
import SelectWidget from '../SelectWidget/SelectWidget';

export default {
  TextWidget,
  RadioWidget,
  SelectWidget,
};
